<section class="mx-auto w-full max-w-7xl px-4 py-8 sm:px-6 lg:px-8">
  <div class="mb-6 flex flex-wrap items-start justify-between gap-3">
    <div>
      <h2 class="text-2xl font-semibold text-slate-900">
        Usuarios por Empresa
      </h2>
      <p class="mt-1 text-sm text-slate-500">
        Gestiona empleados desde la cuenta super-usuario
      </p>
    </div>

    <div class="flex gap-2">
      <button
        class="inline-flex items-center gap-2 rounded-lg border border-slate-300 bg-white px-3 py-2 text-sm font-medium text-slate-700 transition hover:bg-slate-50"
        (click)="goToEmpresas()"
      >
        <i class="bi bi-buildings"></i>
        Ver empresas
      </button>
      <button
        class="inline-flex items-center gap-2 rounded-lg bg-slate-900 px-3 py-2 text-sm font-medium text-white transition hover:bg-slate-700"
        (click)="openCreateModal(modalUsuario)"
      >
        <i class="bi bi-person-plus"></i>
        Nuevo usuario
      </button>
    </div>
  </div>

  <div class="mb-5 rounded-2xl border border-slate-200 bg-white p-4 shadow-sm">
    <label
      class="mb-2 block text-sm font-medium text-slate-700"
      for="empresa-select"
    >
      Empresa
    </label>
    <select
      id="empresa-select"
      class="w-full rounded-lg border border-slate-300 px-3 py-2 text-sm text-slate-700 outline-none transition focus:border-sky-500 focus:ring-2 focus:ring-sky-200 disabled:cursor-not-allowed disabled:bg-slate-100"
      [(ngModel)]="selectedEmpresaId"
      (change)="onEmpresaChange()"
      [disabled]="loadingEmpresas"
    >
      @for (empresa of empresas; track empresa.id) {
        <option [ngValue]="empresa.id">
          {{ empresa.nombre }} ({{ empresa.ruc }})
        </option>
      }
    </select>
    @if (loadingEmpresas) {
      <small class="mt-2 block text-xs text-slate-500"
        >Cargando empresas...</small
      >
    }
  </div>

  @if (error) {
    <div
      class="mb-5 rounded-xl border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-700"
      role="alert"
    >
      <i class="bi bi-exclamation-triangle mr-2"></i>{{ error }}
    </div>
  }

  <div
    class="overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-sm"
  >
    <div
      class="flex items-center justify-between border-b border-slate-200 px-4 py-3"
    >
      <h5 class="text-base font-semibold text-slate-900">Lista de usuarios</h5>
      @if (selectedEmpresaNombre) {
        <span
          class="rounded-full border border-slate-300 bg-slate-100 px-3 py-1 text-xs font-medium text-slate-700"
        >
          {{ selectedEmpresaNombre }}
        </span>
      }
    </div>

    @if (loadingUsuarios) {
      <div class="flex items-center justify-center gap-2 px-4 py-12">
        <div
          class="h-5 w-5 animate-spin rounded-full border-2 border-slate-300 border-t-sky-600"
        ></div>
        <span class="text-sm text-slate-500">Cargando usuarios...</span>
      </div>
    } @else {
      <div class="overflow-x-auto">
        <table class="min-w-full divide-y divide-slate-200 text-sm">
          <thead class="bg-slate-50">
            <tr>
              <th class="px-4 py-3 text-left font-semibold text-slate-600">
                Nombre
              </th>
              <th class="px-4 py-3 text-left font-semibold text-slate-600">
                Email
              </th>
              <th class="px-4 py-3 text-left font-semibold text-slate-600">
                Teléfono
              </th>
              <th class="px-4 py-3 text-left font-semibold text-slate-600">
                Permisos
              </th>
              <th class="px-4 py-3 text-left font-semibold text-slate-600">
                Estado
              </th>
              <th class="px-4 py-3 text-right font-semibold text-slate-600">
                Acciones
              </th>
            </tr>
          </thead>
          <tbody class="divide-y divide-slate-200 bg-white">
            @for (usuario of usuarios; track usuario.id) {
              <tr class="hover:bg-slate-50">
                <td class="px-4 py-3 font-medium text-slate-900">
                  {{ usuario.nombre_completo }}
                </td>
                <td class="px-4 py-3 text-slate-700">{{ usuario.email }}</td>
                <td class="px-4 py-3 text-slate-700">
                  {{ usuario.telefono || "-" }}
                </td>
                <td class="px-4 py-3 text-xs text-slate-500">
                  {{ (usuario.permisos || []).join(", ") || "-" }}
                </td>
                <td class="px-4 py-3">
                  <span
                    class="inline-flex rounded-full px-2.5 py-1 text-xs font-medium"
                    [class.bg-emerald-100]="!isDeleted(usuario)"
                    [class.text-emerald-700]="!isDeleted(usuario)"
                    [class.bg-slate-200]="isDeleted(usuario)"
                    [class.text-slate-600]="isDeleted(usuario)"
                  >
                    {{ isDeleted(usuario) ? "Inactivo" : "Activo" }}
                  </span>
                </td>
                <td class="px-4 py-3 text-right">
                  <div class="inline-flex gap-2">
                    <button
                      class="rounded-lg border border-sky-300 px-2.5 py-1.5 text-sky-700 transition hover:bg-sky-50 disabled:cursor-not-allowed disabled:opacity-50"
                      (click)="openEditModal(usuario, modalUsuario)"
                      [disabled]="isDeleted(usuario)"
                    >
                      <i class="bi bi-pencil"></i>
                    </button>
                    <button
                      class="rounded-lg border border-red-300 px-2.5 py-1.5 text-red-700 transition hover:bg-red-50 disabled:cursor-not-allowed disabled:opacity-50"
                      (click)="openDeleteModal(usuario, modalEliminarUsuario)"
                      [disabled]="isDeleted(usuario)"
                    >
                      <i class="bi bi-trash"></i>
                    </button>
                  </div>
                </td>
              </tr>
            }

            @if (!loadingUsuarios && usuarios.length === 0) {
              <tr>
                <td
                  colspan="6"
                  class="px-4 py-12 text-center text-sm text-slate-500"
                >
                  <i class="bi bi-people mb-2 block text-3xl"></i>
                  No hay usuarios registrados en esta empresa
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    }
  </div>
</section>

<ng-template #modalUsuario let-modal>
  <div class="p-5">
    <div class="mb-4 flex items-center justify-between">
      <h5 class="text-lg font-semibold text-slate-900">
        {{ editingUsuario ? "Editar usuario" : "Nuevo usuario" }}
      </h5>
      <button
        class="rounded-lg border border-slate-300 px-2 py-1 text-slate-600 transition hover:bg-slate-100"
        (click)="modal.dismiss('cross-click')"
      >
        <i class="bi bi-x"></i>
      </button>
    </div>

    <div class="mb-3">
      <label class="mb-1 block text-sm font-medium text-slate-700"
        >Nombre completo</label
      >
      <input
        class="w-full rounded-lg border border-slate-300 px-3 py-2 text-sm outline-none transition focus:border-sky-500 focus:ring-2 focus:ring-sky-200"
        type="text"
        [(ngModel)]="form.nombre_completo"
        maxlength="50"
      />
    </div>

    <div class="mb-3">
      <label class="mb-1 block text-sm font-medium text-slate-700">Email</label>
      <input
        class="w-full rounded-lg border border-slate-300 px-3 py-2 text-sm outline-none transition focus:border-sky-500 focus:ring-2 focus:ring-sky-200"
        type="email"
        [(ngModel)]="form.email"
        maxlength="120"
      />
    </div>

    <div class="mb-3">
      <label class="mb-1 block text-sm font-medium text-slate-700">
        {{ editingUsuario ? "Nueva contraseña (opcional)" : "Contraseña" }}
      </label>
      <input
        class="w-full rounded-lg border border-slate-300 px-3 py-2 text-sm outline-none transition focus:border-sky-500 focus:ring-2 focus:ring-sky-200"
        type="password"
        [(ngModel)]="form.contra"
        maxlength="40"
      />
      <small class="mt-1 block text-xs text-slate-500">
        Debe incluir mayúsculas, minúsculas y números.
      </small>
    </div>

    <div class="mb-3">
      <label class="mb-1 block text-sm font-medium text-slate-700"
        >Teléfono</label
      >
      <input
        class="w-full rounded-lg border border-slate-300 px-3 py-2 text-sm outline-none transition focus:border-sky-500 focus:ring-2 focus:ring-sky-200"
        type="text"
        [(ngModel)]="form.telefono"
        maxlength="15"
      />
    </div>

    <div class="mb-5">
      <label class="mb-1 block text-sm font-medium text-slate-700">
        Permisos (separados por coma)
      </label>
      <input
        class="w-full rounded-lg border border-slate-300 px-3 py-2 text-sm outline-none transition focus:border-sky-500 focus:ring-2 focus:ring-sky-200"
        type="text"
        [(ngModel)]="form.permisosRaw"
      />
      <small class="mt-1 block text-xs text-slate-500"
        >Ejemplo: VENDEDOR o ADMINISTRADOR</small
      >
    </div>

    <div class="flex justify-end gap-2">
      <button
        class="rounded-lg border border-slate-300 bg-white px-3 py-2 text-sm font-medium text-slate-700 transition hover:bg-slate-50"
        (click)="modal.dismiss('cancel')"
      >
        Cancelar
      </button>
      <button
        class="rounded-lg bg-slate-900 px-3 py-2 text-sm font-medium text-white transition hover:bg-slate-700"
        (click)="saveUsuario(modal)"
      >
        Guardar
      </button>
    </div>
  </div>
</ng-template>

<ng-template #modalEliminarUsuario let-modal>
  <div class="p-5">
    <div class="mb-4 flex items-center justify-between">
      <h5 class="text-lg font-semibold text-slate-900">Eliminar usuario</h5>
      <button
        class="rounded-lg border border-slate-300 px-2 py-1 text-slate-600 transition hover:bg-slate-100"
        (click)="modal.dismiss('cross-click')"
      >
        <i class="bi bi-x"></i>
      </button>
    </div>

    <div class="space-y-2 text-sm text-slate-700">
      <p>¿Eliminar al usuario seleccionado?</p>
      <p class="font-semibold text-slate-900">
        {{ deletingUsuario?.nombre_completo }}
      </p>
      <p>Esta acción se puede revertir desde backend.</p>
    </div>

    <div class="mt-5 flex justify-end gap-2">
      <button
        class="rounded-lg border border-slate-300 bg-white px-3 py-2 text-sm font-medium text-slate-700 transition hover:bg-slate-50"
        (click)="modal.dismiss('cancel')"
      >
        Cancelar
      </button>
      <button
        class="rounded-lg bg-red-600 px-3 py-2 text-sm font-medium text-white transition hover:bg-red-500"
        (click)="removeUsuario(modal)"
      >
        Eliminar
      </button>
    </div>
  </div>
</ng-template>

<app-toast aria-live="polite" aria-atomic="true"></app-toast>
